import axios from "axios";

const api = axios.create();

if (config.public_url.search('http') > -1) {
	api.defaults.baseURL = config.public_url.substr(-1) === "/" ? config.public_url : config.public_url.slice(0, -1);
}
api.defaults.withCredentials = true;
api.defaults.headers.common["Ajax"] = true;
api.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
api.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded";

api.interceptors.request.use(
	function (config) {
		let token = window.authService.retrieveToken();

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	function (response) {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return response;
	},
	function (error) {
		if (error.status === 406 && error.response.data.doCheckbox) {
			console.log("recaptcha challenge", error);
			window.reCaptchaService.doCheckbox();
		} else if (error.status === 401) {
			window.authService.showDialog();
		}
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		return Promise.reject(error);
	}
);

window.axios = api;